<template>
  <FirstTimeInfoModal
    :show="show"
    :title="$t('views.camera.calibration.title')"
    :subtitle="$t('views.camera.calibration.subtitle')"
    :message="$t('views.camera.calibration.message')"
    :setupLabel="$t('views.camera.calibration.calibrateNow')"
    :continueLabel="$t('views.camera.calibration.skip')"
    @update:show="$emit('update:show', $event)"
    @setup="handleCalibrate"
    @continue="handleSkip" />
</template>

<script setup>
  import FirstTimeInfoModal from '@/components/ui/feedback/FirstTimeInfoModal.vue'

  defineProps({
    show: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['update:show', 'calibrate', 'skip'])

  function handleCalibrate(dontShowAgain) {
    emit('calibrate', dontShowAgain)
  }

  function handleSkip(dontShowAgain) {
    emit('skip', dontShowAgain)
  }
</script>
